// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr{border-color:rgba(255,255,255,.5);border-bottom:0;height:2px}", "",{"version":3,"sources":["webpack://./app/pages/components/notes/modal-edit/index.scss"],"names":[],"mappings":"AAAA,GACI,iCAAA,CACA,eAAA,CACA,UAAA","sourcesContent":["hr {\n    border-color: rgba(255, 255, 255, 0.5);\n    border-bottom: 0;\n    height: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
